import { useEffect, useState } from 'react'

import { Col, Form, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap'
import { toast } from 'react-toastify'

import {
  ArrowClockwise,
  CheckCircleFill,
  EyeFill,
  EyeSlashFill,
  HouseAddFill,
  HouseXFill,
  PencilFill,
  PlusCircleFill,
  Search,
  XCircleFill,
} from 'react-bootstrap-icons'

import { CustomButton } from '../../../components/CustomButton'
import { CustomSpinner } from '../../../components/CustomSpinner'
import { IconButton } from '../../../components/IconButton'
import Navbar from '../../../components/navbar/navbar'

import { sendErrorApiMessage } from '../../../utils/sendErrorApiMessage'

import { Ask } from '../../../components/Ask'
import { Center } from '../../../components/Center'
import { useOrdenation } from '../../../hooks/useOrdenation'
import WmsPickingService from '../../../services/database/WmsPickingService'
import WmsProductService from '../../../services/database/WmsProductService'
import { getValue } from '../../../utils/getValue'
import { ModalEnderecamento } from './ModalEnderecamento'
import {
  default as ModalCreateProduct,
  default as ModalUpdateProduct,
} from './ModalProduto'

export function WMSProdutos() {
  const [products, setProducts] = useState([])
  const [isProductsLoading, setIsProductsLoading] = useState(true)

  const [type, setType] = useState('sku')
  const [search, setSearch] = useState('')

  const [isSearchProductLoading, setIsSearchProductLoading] = useState(false)
  const [isCreateProductLoading, setIsCreateProductLoading] = useState(false)
  const [isUpdateProductLoading, setIsUpdateProductLoading] = useState(false)
  const [isDeleteProductLoading, setIsDeleteProductLoading] = useState({})

  const [selectedProduct, setSelectedProduct] = useState(null)

  const [isModalCreateProductOpen, setIsModalCreateProductOpen] =
    useState(false)

  const [isModalUpdateProductOpen, setIsModalUpdateProductOpen] =
    useState(false)

  const [isModalEnderecamentoOpen, setIsModalEnderecamentoOpen] =
    useState(false)

  const [selectedProductAddress, setSelectedProductAddress] = useState({})

  const { filteredItems, Th, Paginate, setItemsPerPage } = useOrdenation(
    products,
    'sku',
  )

  async function handleSearchProduct() {
    try {
      setIsSearchProductLoading(true)

      const data = await WmsProductService.getAll({ type, search })

      setSelectedProductAddress({})
      setProducts(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Houve um problema ao encontrar o produto!')
    } finally {
      setIsSearchProductLoading(false)
    }
  }

  async function handleCreateProduct(data) {
    try {
      setIsCreateProductLoading(true)

      if (!data.descricao) {
        return toast.error(
          'É necessário colocar um produto, digite um SKU válido!',
        )
      }

      await WmsProductService.create(data)

      loadProducts()
      toast.success(`Produto criado com sucesso!`)
      setIsModalCreateProductOpen(false)
    } catch (err) {
      if (err?.response?.data?.message === 'Produto já existente!') {
        toast.info('Produto já cadastrado, redirecionando para edição...')

        setIsModalCreateProductOpen(false)

        setSelectedProduct((prevState) => ({
          ...prevState,
          sku: data.sku,
        }))

        setIsModalUpdateProductOpen(true)

        return
      }

      sendErrorApiMessage(err, 'Não foi possível criar o produto!')
    } finally {
      setIsCreateProductLoading(false)
    }
  }

  async function handleUpdateProduct(data) {
    const { sku, ...product } = data

    try {
      setIsUpdateProductLoading(true)

      await WmsProductService.update(sku, product)

      loadProducts()
      toast.success(`Produto atualizado com sucesso!`)
      setIsModalUpdateProductOpen(false)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o produto!')
    } finally {
      setIsUpdateProductLoading(false)
    }
  }

  async function handleDeleteAddressProduct(sku, codendereco, index) {
    try {
      setIsDeleteProductLoading((prevState) => ({
        ...prevState,
        [index]: true,
      }))

      await WmsPickingService.delete(sku, codendereco)

      loadProducts()
      toast.success('Endereçamento removido com sucesso!')
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível remover o endereçamento!')
    } finally {
      setIsDeleteProductLoading((prevState) => ({
        ...prevState,
        [index]: false,
      }))
    }
  }

  async function loadProducts() {
    try {
      setIsProductsLoading(true)

      const data = await WmsProductService.getAll()

      setSelectedProductAddress({})
      setProducts(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao carregar os produtos!')
    } finally {
      setIsProductsLoading(false)
    }
  }

  useEffect(() => {
    loadProducts()
  }, [])

  return (
    <>
      <Navbar />

      <div className="mt-page">
        <h1>Produtos</h1>

        <Row className="mb-3">
          <Col md={2}>
            <Form.Label>Tipo de Pesquisa</Form.Label>
            <Form.Select
              value={type}
              onChange={(e) => {
                setType(e.target.value)
              }}
            >
              <option value="sku">SKU</option>
              <option value="descricao">Descrição</option>
              <option value="codendereco">Endereço</option>
            </Form.Select>
          </Col>

          <Col md={5}>
            <Form.Label>Pequisa</Form.Label>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 10,
              }}
            >
              <Form.Control
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Digite"
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    if (e.target.value) {
                      handleSearchProduct()
                    }
                  }
                }}
              />

              <IconButton
                disabled={!search}
                isLoading={isSearchProductLoading}
                onClick={handleSearchProduct}
              >
                <Search />
              </IconButton>
            </div>
          </Col>
        </Row>

        <div
          style={{
            display: 'flex',
            alignItems: 'flex-end',
            gap: 10,
          }}
        >
          <section>
            <Form.Label>Produtos por página</Form.Label>
            <Form.Select
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value))
              }}
              style={{
                width: '200px',
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
          </section>

          <CustomButton
            noMargin
            title="Adicionar"
            color="#009009"
            onClick={() => setIsModalCreateProductOpen(true)}
          >
            <PlusCircleFill />
          </CustomButton>

          <CustomButton
            noMargin
            title="Recarregar"
            color="#0070da"
            onClick={loadProducts}
            isLoading={isProductsLoading}
            isLoadingText="Recarregando..."
          >
            <ArrowClockwise />
          </CustomButton>
        </div>

        {isProductsLoading ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <CustomSpinner />
          </div>
        ) : filteredItems.length === 0 ? (
          <div
            style={{
              flex: 1,
              minHeight: '100%',
              padding: 10,
              textAlign: 'center',
            }}
          >
            <p>Sem produtos cadastrados</p>
          </div>
        ) : (
          <>
            <Center jc="flex-end">
              <p>
                Mostrando <strong>{filteredItems.length}</strong> de{' '}
                <strong>{products.length}</strong> produtos
              </p>
            </Center>

            <Table
              striped
              bordered
              hover
              responsive
            >
              <thead>
                <tr>
                  <Th />
                  <Th
                    value="sku"
                    label="SKU"
                  />
                  <Th
                    value="descricao"
                    label="Descrição"
                  />
                  <Th
                    value="sku_principal"
                    label="SKU Principal"
                  />

                  <Th label="Ações" />
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((product, index) => (
                  <>
                    <tr key={product.sku}>
                      <td>
                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              {product.codendereco
                                ? 'Endereçado'
                                : 'Não Endereçado'}
                            </Tooltip>
                          }
                        >
                          {product.codendereco ? (
                            <CheckCircleFill
                              size={20}
                              color="#2ecc71"
                            />
                          ) : (
                            <XCircleFill
                              size={20}
                              color="#e74c3c"
                            />
                          )}
                        </OverlayTrigger>
                      </td>
                      <td>{product.sku}</td>
                      <td>{product.descricao}</td>
                      <td>{getValue(product.sku_principal)} </td>
                      <td
                        style={{
                          display: 'flex',
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            gap: 5,
                          }}
                        >
                          <OverlayTrigger overlay={<Tooltip>Editar</Tooltip>}>
                            <IconButton
                              color="#ff7820"
                              onClick={() => {
                                setSelectedProduct(product)
                                setIsModalUpdateProductOpen(true)
                              }}
                            >
                              <PencilFill />
                            </IconButton>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Endereçamento</Tooltip>}
                          >
                            <IconButton
                              color="#009009"
                              onClick={() => {
                                setSelectedProduct(product)
                                setIsModalEnderecamentoOpen(true)
                              }}
                            >
                              <HouseAddFill />
                            </IconButton>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Remover Endereçamento</Tooltip>}
                          >
                            <IconButton
                              isLoading={isDeleteProductLoading[index]}
                              color="#c0392b"
                              isDisabled={!product.codendereco}
                              onClick={() =>
                                Ask(
                                  `Remover endereçamento do produto "${product.descricao}"?`,
                                  () =>
                                    handleDeleteAddressProduct(
                                      product.sku,
                                      product.codendereco,
                                      index,
                                    ),
                                )
                              }
                            >
                              <HouseXFill />
                            </IconButton>
                          </OverlayTrigger>

                          <OverlayTrigger
                            overlay={<Tooltip>Visualizar Endereço</Tooltip>}
                          >
                            <IconButton
                              isDisabled={!product.codendereco}
                              color="#155dec"
                              onClick={() =>
                                selectedProductAddress[index]?.codendereco
                                  ? setSelectedProductAddress({})
                                  : setSelectedProductAddress({
                                      [index]: product,
                                    })
                              }
                            >
                              {selectedProductAddress[index]?.codendereco ? (
                                <EyeSlashFill />
                              ) : (
                                <EyeFill />
                              )}
                            </IconButton>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>

                    {selectedProductAddress[index]?.codendereco && (
                      <tr>
                        <td colSpan={5}>
                          <Table>
                            <thead>
                              <tr>
                                <th>Cód. End.</th>
                                <th>Depósito</th>
                                <th>Rua</th>
                                <th>Prédio</th>
                                <th>Nível</th>
                                <th>Apartamento</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>
                                  {selectedProductAddress[index].codendereco}
                                </td>
                                <td>
                                  {selectedProductAddress[index].deposito}
                                </td>
                                <td>{selectedProductAddress[index].rua}</td>
                                <td>{selectedProductAddress[index].predio}</td>
                                <td>{selectedProductAddress[index].nivel}</td>
                                <td>{selectedProductAddress[index].apto}</td>
                              </tr>
                            </tbody>
                          </Table>
                        </td>
                      </tr>
                    )}
                  </>
                ))}
              </tbody>
            </Table>

            <Paginate />
          </>
        )}
      </div>

      {isModalCreateProductOpen && (
        <ModalCreateProduct
          title="Adicionar Produto"
          isOpen={isModalCreateProductOpen}
          onClose={() => setIsModalCreateProductOpen(false)}
          onSubmit={handleCreateProduct}
          isRequestLoading={isCreateProductLoading}
        />
      )}

      {isModalUpdateProductOpen && (
        <ModalUpdateProduct
          title="Editar Produto"
          isOpen={isModalUpdateProductOpen}
          onClose={() => setIsModalUpdateProductOpen(false)}
          onSubmit={handleUpdateProduct}
          isRequestLoading={isUpdateProductLoading}
          productSku={selectedProduct.sku}
        />
      )}

      {isModalEnderecamentoOpen && (
        <ModalEnderecamento
          title="Endereçamento"
          isOpen={isModalEnderecamentoOpen}
          onClose={() => setIsModalEnderecamentoOpen(false)}
          productSku={selectedProduct.sku}
          loadProducts={loadProducts}
        />
      )}
    </>
  )
}
